import React, { Component } from "react";
import { observer } from "mobx-react";
import { Navigate, useParams } from "react-router-dom";
import useStores from "../../../../utils/useStores";

import { Alert } from "../../Component/Alert";

import FormControlLabel from "@mui/material/FormControlLabel";
import Grid from "@mui/material/Grid";
import FormGroup from "@mui/material/FormGroup";
import SidebarObject from "../../Component/SidebarObject";
import Paper from "@mui/material/Paper";
import Switch from "@mui/material/Switch";
import TextField from "@mui/material/TextField";

import Box from "@mui/material/Box";
import Button from "@mui/material/Button";

import PexelsPicker from "./PexelsPicker";

import "./style.css";

class SubjectSettings extends Component<any, any> {
    constructor(props: any) {
        super(props);

        this.state = {
            error: "",
            newObjectModalIsOpen: false,
            editObjectModalIsOpen: false,
            updateComponent: 0,
            publicWarning: false,
            redirectToNewSlug: undefined,
            imageURL: ""
        };

        this.handleTitleChange = this.handleTitleChange.bind(this);
        this.handleDescriptionChange = this.handleDescriptionChange.bind(this);
        this.onSubmit = this.onSubmit.bind(this);
        this.subject = this.subject.bind(this);
        this.setPexelsURL = this.setPexelsURL.bind(this);
        this.togglePublic = this.togglePublic.bind(this);
    }

    componentDidMount() {
        this.fetchSubjects();
    }

    fetchSubjects() {
        this.props.rootStore.subjectStore.fetchOne(
            this.props.match.params.user,
            this.props.match.params.subject
        );
    }

    subjectHashKey() {
        return `${this.props.match.params.user}/${this.props.match.params.subject}`;
    }

    subject() {
        return this.props.rootStore.subjectStore.subjects.get(
            this.subjectHashKey()
        );
    }

    handleSubjectFieldChange(field: string, value: string) {
        var subject = this.subject();
        subject[field] = value;
        this.props.rootStore.subjectStore.subjects.set(
            this.subjectHashKey(),
            subject
        );
    }

    handleTitleChange(ev: any) {
        this.handleSubjectFieldChange("title", ev.target.value);
    }

    handleDescriptionChange(ev: any) {
        this.handleSubjectFieldChange("description", ev.target.value);
    }

    setPexelsURL(pexels_url: string) {
        var subject = this.subject();
        subject.setPexelsURL(pexels_url);
        this.props.rootStore.subjectStore.subjects.set(
            this.subjectHashKey(),
            subject
        );
    }

    togglePublic(ev: any) {
        var subject = this.subject();
        console.log(subject);
        if (!subject.public) {
            subject.public = !subject.public;
            this.props.rootStore.subjectStore.subjects.set(
                this.subjectHashKey(),
                subject
            );
        } else {
            this.setState({
                publicWarning: "Sorry, you can't make a public subject private"
            });
        }
    }

    onSubmit() {
        var component = this;
        const oldSlug = this.props.match.params.subject;
        this.props.rootStore.subjectStore.subjects
            .get(this.subjectHashKey())
            .save((err: any, newSlug: string) => {
                if (err) {
                    component.setState({
                        error: err.title
                    });
                }
                if (oldSlug !== newSlug) {
                    component.setState({
                        redirectToNewSlug: newSlug
                    });
                }
            });
    }

    render() {
        if (this.state.redirectToNewSlug) {
            let newSubjectSlug = `${this.props.match.params.user}/${this.state.redirectToNewSlug}`;
            console.log(`Redirecting to ${newSubjectSlug}`);
            return <Navigate to={`/modquiz/subjects/${newSubjectSlug}/settings`} />;
        }

        let html: JSX.Element = <div></div>;

        const subject = this.subject();

        const isLoggedIn = this.props.rootStore.profileStore.isLoggedIn;

        if (!subject) return html;

        return (
            <Grid container direction="row">
                <Grid item xs={"auto"} sm={3} md={2}>
                    <SidebarObject
                        subjectHashKey={subject.hash_key}
                        hasCreateAccess={isLoggedIn}
                        subject={subject}
                        subject_user={subject.user}
                        subject_slug={subject.slug}
                    />
                </Grid>
                <Grid item xs={12} sm={9} md={10}>
                    <Paper className="" square>
                        <div className="container SubjectSettings">
                            <Grid container spacing={3}>
                                <Grid item xs={12} lg={8}>
                                    <br />

                                    <h1>Settings</h1>
                                    <span className="subheading">
                                        Manage settings for this subject
                                    </span>
                                    <hr className="subheading-divider" />
                                    <br />
                                </Grid>
                                <Grid item xs={12} lg={8}>
                                    <FormGroup>
                                        <TextField
                                            variant="outlined"
                                            id="title"
                                            onChange={this.handleTitleChange}
                                            value={subject.title}
                                            label="Title"
                                        />
                                    </FormGroup>
                                </Grid>
                                <Grid item xs={12} lg={8}>
                                <Box my={3}>

                                    <FormGroup>
                                        <TextField
                                            id="description"
                                            variant="outlined"
                                            value={subject.description}
                                            className="form-control"
                                            label="Description"
                                            onChange={
                                                this.handleDescriptionChange
                                            }
                                        />
                                    </FormGroup>
                                    </Box>

                                </Grid>
                                <Grid item xs={12} lg={8}>
                                    <FormControlLabel
                                        control={
                                            <Switch
                                                color="secondary"
                                                name="togglePublic"
                                                onChange={this.togglePublic}
                                                checked={subject.public}
                                            />
                                        }
                                        label="Public"
                                    />
                                    <span className="text-warning">
                                        {this.state.publicWarning}
                                    </span>
                                </Grid>
                            </Grid>
                            <Box my={2} />
                            <Grid item xs={12}>
                                <div className="form-group">
                                    <PexelsPicker
                                        pexels_url={subject.pexels_url}
                                        subject={this.subject()}
                                        setPexelsURL={this.setPexelsURL}
                                    />
                                </div>
                            </Grid>
                            <br />
                            <Alert status="error" message={this.state.error} />
                            <br />
                            <Button
                                onClick={this.onSubmit}
                                color="primary"
                                variant="contained"
                            >
                                Save
                            </Button>
                        </div>
                    </Paper>
                </Grid>
            </Grid>
        );
    }
}

const SubjectSettingsRoute = observer(() => {
    const rootStore = useStores();
    const params = useParams<{ user: string; subject: string }>();
    return <SubjectSettings rootStore={rootStore} match={{ params }} />;
});

export default SubjectSettingsRoute;
